module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "total container-room"
  }, [_c('div', [_c('select-button', {
    staticClass: "mb-3 field",
    attrs: {
      "item-text": "name",
      "item-value": "id",
      "items": _vm.typesRooms
    },
    on: {
      "change": _vm.setRoomTypeIdToAllDays
    },
    model: {
      value: (_vm.roomType),
      callback: function($$v) {
        _vm.roomType = $$v
      },
      expression: "roomType"
    }
  }), _vm._v(" "), _c('select-button', {
    staticClass: "mb-3 field",
    attrs: {
      "disabled": "",
      "item-text": "codeRoom",
      "item-value": "id",
      "items": _vm.roomsNumbers
    },
    model: {
      value: (_vm.roomNumber),
      callback: function($$v) {
        _vm.roomNumber = $$v
      },
      expression: "roomNumber"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "field mb-2 white-color",
    attrs: {
      "label-text": "Tarifa"
    },
    on: {
      "input": _vm.updateAllRates
    },
    model: {
      value: (_vm.generalRate),
      callback: function($$v) {
        _vm.generalRate = $$v
      },
      expression: "generalRate"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "total-amount"
  }, [_vm._v("Total: " + _vm._s(_vm.totalAmount))])], 1), _vm._v(" "), _c('div', {
    staticClass: "close"
  }, [_vm._v("X")])]), _vm._v(" "), _vm._l((_vm.model), function(room, indexRoom) {
    return _c('div', {
      key: indexRoom,
      class: [
        'number-room',
        'container-room', !room.listRooms ? 'not-avaliable' : null, !room.idRoom ? 'not-avaliable' : null,
        room.isDirty ? 'dirty-day' : null ]
    }, [_c('select-button', {
      staticClass: "mb-3 field",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.typesRooms
      },
      on: {
        "change": function($event) {
          _vm.getRoomsNumber($event, room, false)
        }
      },
      model: {
        value: (room.roomTypeId),
        callback: function($$v) {
          room.roomTypeId = $$v
        },
        expression: "room.roomTypeId"
      }
    }), _vm._v(" "), _c('select-button', {
      staticClass: "mb-3 field",
      attrs: {
        "item-text": "codeRoom",
        "item-value": "id",
        "items": room.listRooms
      },
      on: {
        "change": function($event) {
          _vm.setNumberRoom($event, indexRoom, _vm.reservationIndex, _vm.model)
        }
      },
      model: {
        value: (room.idRoom),
        callback: function($$v) {
          room.idRoom = $$v
        },
        expression: "room.idRoom"
      }
    }), _vm._v(" "), _c('input-text', {
      staticClass: "field",
      attrs: {
        "label-text": "Tarifa",
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.updateRate($event, indexRoom, _vm.reservationIndex, _vm.model)
        }
      },
      model: {
        value: (room.rate),
        callback: function($$v) {
          room.rate = _vm._n($$v)
        },
        expression: "room.rate"
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16a2f739","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/SelectRoomNumber.vue
// module id = 1218
// module chunks = 1 20